import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router";

export const AsideMenu = () => {
    const location = useLocation();
    const menu = [
        { link: "/", name: "About Me", },
        // { link: "/uix", name: "UI/UX Design", },
        { link: "/apps", name: "Mobile & Web Apps", },
        // { link: "/snippets", name: "Code Snippets", },
        // { link: "/templates", name: "Themes & Templates", },
        { link: "/hello", name: "Say Hello", },
    ];
    return (
        <nav id="martin-main-menu" role="navigation" className="navbar">
            <div id="navbar" className="collapse">
                <ul>
                    {menu.map((mnu, i) => {
                        return <li className={((mnu.link === location.pathname || location.pathname.includes(mnu.link + '/')) ? 'active' : '')} key={i}><Link to={mnu.link}>{mnu.name}</Link></li>
                    })}
                </ul>
            </div>
        </nav>
    );
}